import React from "react";
import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/community-guidelines", label: "Guidelines" },
];

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen flex flex-col bg-surface-elevated text-text-primary font-sans">
      {/* Header */}
      <header className="border-b border-border px-6 md:px-20 py-4">
        <Link to="/" className="text-2xl font-bold text-text-primary">
          Traces
        </Link>
        <nav className="flex gap-4 mt-2 text-sm text-text-muted">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="hover:text-text-primary transition"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </header>

      {/* Document title */}
      <div className="px-6 md:px-20 pt-10 pb-4 max-w-3xl mx-auto w-full">
        <h1 className="text-3xl font-bold text-text-primary">{title}</h1>
        <p className="text-sm text-text-muted mt-2">
          Last updated: {lastUpdated}
        </p>
      </div>

      {/* Content */}
      <main className="flex-1 px-6 md:px-20 pb-16 max-w-3xl mx-auto w-full">
        <div
          className="
            text-text-secondary text-sm md:text-base leading-relaxed
            [&_h2]:text-text-primary [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3
            [&_h3]:text-text-primary [&_h3]:text-lg [&_h3]:font-medium [&_h3]:mt-5 [&_h3]:mb-2
            [&_p]:mb-4
            [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-4
            [&_li]:mb-1
            [&_a]:text-primary [&_a]:underline
          "
        >
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-10 px-6 md:px-20 border-t text-sm text-text-muted flex flex-col md:flex-row justify-between">
        <span>© {new Date().getFullYear()} Traces. All rights reserved.</span>
        <div className="flex gap-6 mt-4 md:mt-0">
          {FOOTER_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="hover:text-text-primary transition"
            >
              {link.label}
            </Link>
          ))}
        </div>
      </footer>
    </div>
  );
}
